import type React from 'react'
import { useState } from 'react'

import { clsJoin } from '@/utils'
import { FormLabel } from '../FormLabel'
import css from './styles.module.css'

interface Props {
  name: string
  label: string
  value: string
  canEdit: boolean
  readOnly: boolean
  counterText?: string
  placeholder?: string
  cnClassName: string
  counterClassName?: string
  onChange: (value: string) => void
  onBlur: () => void
}

export const FormInput: React.FC<Props> = ({
  name,
  label,
  value,
  canEdit,
  readOnly,
  counterText,
  placeholder = '',
  cnClassName,
  counterClassName,
  onChange,
  onBlur,
}) => {
  const [showCounter, setShowCounter] = useState(false)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value)
  }

  const handleFocus = () => {
    setShowCounter(true)
  }

  const handleBlur = () => {
    setShowCounter(false)
    onBlur()
  }
  const disabled = !canEdit || readOnly

  return (
    <div className={clsJoin(css.form_input, cnClassName)}>
      <FormLabel
        name={name}
        label={label}
        showCounter={showCounter}
        counterText={counterText}
        counterClassName={counterClassName}
      />

      <input
        id={name}
        type="text"
        name={name}
        className={clsJoin(css.form_input_field, disabled && css.disabled)}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        onChange={handleOnChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  )
}
